import { WEB_URL } from "@/config/endpoints"
import IMAGES from "@/public/assets/img"


export default {
  SeoContent:{
      title: 'Global Supply Chain Finance Company in US | Innovative Solution',
      url: WEB_URL+'/en-us',
      name:'description',
      description:'Credlix is a digital Global Supply Chain Finance Company in US from Moglix that provides quick, collateral-free working capital solutions for the entire supply chain.',
      keyword: 'supply chain finance, supply chain finance in india, supply chain in finance,supply chain finance company', 
      imagePath:IMAGES.HOMEIMG.bigLogoNew.src
    },
    indiaBanner:false,
    BANNER:{
      h1:'Empowering Global Trade with Smart Financing Solutions',
      para:'Credlix offers digital, collateral-free financial solutions that accelerate business growth in international trade.',
      btn1:'Cross Border Trade',
      btn2:'Channel Financing'
    },
    CTASection:{
      heading: 'Ready to Take Your Business to the Next Level?',
      paragraph:'Securing financing for your business.',
      cta: 'Get Financed',
      ctaLink:null
    },
    Logos:[
      {name:'Ashley',image:IMAGES.HOMEIMG.ashleyLogo},
      {name:'Home Goods',image:IMAGES.HOMEIMG.homeGoodsLogo},
      {name:'GE',image:IMAGES.HOMEIMG.geLogo},
      {name:'Ross',image:IMAGES.HOMEIMG.rossLogo},
      // {name:'SpaceX',image:IMAGES.HOMEIMG.spacexLogo},
      {name:'TJX',image:IMAGES.HOMEIMG.tjxLogo},
      {name:'Walmart',image:IMAGES.HOMEIMG.walMart},
    ],
    SolutionsSec:{
      heading:'Experience a game-changing approach to supply chain financing with Credlix!',
      paragraph:'We enable tailored financing solutions powered by cutting-edge tech and an extensive lending network for your business.',
      learnmoreCta : 'Learn More',
      solutions:[
          {heading:'Export Factoring',paragraph:'Avail non-recourse factoring up to 90% of invoice value for buyers in 90+ countries from Credlix up to 120 days. ',src:IMAGES.SHARED.eFinance, color:'#FCE2E8', href: '/export-factoring' },
          {heading:'Channel Financing',paragraph:'Empower your clients with instant, collateral-free capital.',src:IMAGES.SHARED.poFinane, color:'#DBFFF9', href: '/partner-program'},
          {heading:'Global Buyers',paragraph:'Unlock Flexible Financing Solutions as a Buyer for better Supplier Relationship.  ',src:IMAGES.SHARED.sbDiscount, color:'#D5E8FF', href: '/global-buyer'},
      ]
  
    },
    SubSolutionsSec:{
      heading:'Why Choose Credlix?',
      para1:'Tailored Capital Solutions for Your Business',
      para2:'Credlix automates financing, allowing you to focus on growing your business.',
      para3:'Ready to Take Your Business to the Next Level',
      para4:'Securing financing for your business.',
      // src: IMAGES.HomeNew.termsheetClock,
      ctaHref:null,
      ctaText:'Get Financed Now',
      FooterIndiaForm:false,
      subSolutions:[
        {heading:null, src:IMAGES.HomeNew.subSol1,para:"Up to <strong>$5Mn</strong> Funding available within <strong>48 hours</strong>."},
        {heading:null, src:IMAGES.HomeNew.subSol2,para:"<strong>Zero </strong> Collateral required."},
        {heading:null, src:IMAGES.HomeNew.subSol3,para:"Up to <strong>90% of Invoice</strong> Value in working capital."},
        {heading:null, src:IMAGES.HomeNew.subSol4,para:"Manage Multiple <strong>Credit Lines</strong> seamlessly."},
        {heading:null, src:IMAGES.HomeNew.subSol5,para:"Hassle-free process, <strong>secure, and reliable</strong>."},
      ]

  },
  ConuterSec:{
      heading:'From Local Roots To Global Expansion​',
      paragraph:'Credlix Empowers PYMES Growth',
      bannerImg : IMAGES.HomeNew.numbersBg,
      bannerMbImage:null,
      counterList:[
          {heading:'7500', paragraph:'Invoice Funded', smalltext:'+'},
          {heading:'5000', paragraph:'PYMES Onboarded', smalltext:'+'},
          {heading:'$1', paragraph:'Export Financing', smalltext:'Bn+'},
          {heading:'120', paragraph:'Cities Coverage', smalltext:'+'}
      ]
  },
  CapitalSolution:false,
  CapitalSolutionSec:null,
  BookAMeeting:'Book a Meeting Now',
  HowItWorks:{
    heading:'How It Works',
    steps:[
      {id:'1', name:'Exporter Ships Goods', para:'Register your buyers on Credlix and access their credit information within minutes.'},
      {id:'2', name:'Buyer Receives Goods', para:'Coordinate delivery with your buyer and designate Credlix as your factoring partner.'},
      {id:'3', name:'Credlix Finances', para:'Receive an advance of up to 90% of the invoice value after goods delivery is verified.'},
    ]
  },
  Investers:{
    heading:'We are backed by global investors',
    investerslList:[
        {src:IMAGES.HomeNew.sequoiaNew, alt:'Sequoia'},
        {src:IMAGES.HomeNew.accelNew, alt:'accel'},
        {src:IMAGES.HomeNew.falconNew, alt:'falcon'},
        {src:IMAGES.HomeNew.havardNew, alt:'havard'},
        {src:IMAGES.HomeNew.tigerNew, alt:'tiger'},
        {src:IMAGES.HomeNew.jungleNew, alt:'jungle'},
        {src:IMAGES.HomeNew.falconEdge, alt:'falcon Edge'},
        {src:IMAGES.HomeNew.tigerGlobal, alt:'Tiger Global'},
        {src:IMAGES.HomeNew.seedPlus, alt:'Seed Plus'},
        {src:IMAGES.HomeNew.compositeCapital, alt:'Composite Capital'},
        {src:IMAGES.HomeNew.infinanceCorp, alt:'IFC'},
        
    ],
},
GlobalNetwork:{
  heading:'Our <strong>Global Network</strong> <br/>Enable Faster Results',
  para:'With offices in India, USA, UAE, and Mexico regions, Credlix offers localized support and expertise to clients worldwide.',
  flags:[
    {flag:IMAGES.HomeNew.indiaFlag,name:'India'},
    {flag:IMAGES.HomeNew.mexicoFlag,name:'Mexico'},
    {flag:IMAGES.HomeNew.singaporeFlag,name:'Singapore'},
    {flag:IMAGES.HomeNew.usaFlag,name:'USA'},
    {flag:IMAGES.HomeNew.uaeFlag,name:'UAE'},
  ]
},
WhyChooseCredlix:false,
Credibility:{
  heading:'Credibility You Can Trust',
  subHeading:'Backed by industry recognition',
  awards:[
      IMAGES.HomeNew.award1,IMAGES.HomeNew.award2,IMAGES.HomeNew.award3,IMAGES.HomeNew.award4,IMAGES.HomeNew.award5,IMAGES.HomeNew.award6,
      IMAGES.HomeNew.award7,IMAGES.HomeNew.award8,IMAGES.HomeNew.award9,IMAGES.HomeNew.award10,IMAGES.HomeNew.award11,IMAGES.HomeNew.award12
    ],
},
Testimonial:false,
Customers:null,
DownloadApp:false,
blogShow:false,
FAQ:{
  Faq_heading:'FAQs',
  Home_Faq:[
      {   id:0,
        Q:"What is Supply Chain Finance?",
        A:"Any private or public entity is eligible to avail supply chain finance. Sole proprietorship and partnership companies can also use this facility. Supply chain finance is like a high-tech helper for businesses that makes deals smoother, hassle-free, and more cost-effective. It's a set of smart processes using technology to bring down expenses and make things work better for everyone in a business deal. It’s like a tool that helps buyers and sellers in a transaction save money and do things faster."
      },
      {   id:1,
        Q:"What are the Documents Required for Supply Chain Finance?",
        A:"The documents required for supply chain finance is as follows:",
        list:["Identity proof","Address proof","Financial documents","Business ownership documents."]
      },
      {   id:2,
        Q:"What are the Types of trading services offered under Supply Chain Finance?",
        A:"The Types of trading services offered under Supply Chain Finance are as follows:",
        list:["Invoice Discounting","Dynamic Discounting","Supply Chain Financing Platforms","Receivables Finance","Payables Financing","Inventory Financing","Purchase Order Financing","Channel Financing"]
      },
      {   id:3,
        Q:"What is the Eligibility Criteria for Supply Chain Finance?",
        A:"To be able to avail of supply chain financing, the eligibility criteria is as follows:",
        list:["Creditworthiness","Indian Nationality","Business Vintage of at least 3 years","Transaction Volume","Trade Relationship","Invoices and Receivables","Supply Chain Visibility","Compliance","Financial Health","A good CIBIL score"]
      },
      {   id:4,
        Q:"What is the Interest Rates for Supply Chain Finance?",
        A:"There’s no one fixed rate of interest for supply chain finances. It depends on several factors like the provider, companies trustworthiness, creditworthiness, market conditions, and more. The interest rate is mostly competitive in nature."
      },
      {   id:5,
        Q:"How can one apply for Supply Chain Finance?",
        A:"",
        list:["Step 1: Login to our website https://www.credlix.com/","Step 2: Give all the necessary information required. ","Step 3: Go through the eligibility criteria thoroughly. ","Step 4: Agree on the financing terms with Credlix.","Step 5: The final approval."]
      },
      {   id:6,
        Q:"What are the Features & Benefits of Supply Chain Finance?",
        A:"Features and benefits of supply chain finance:",
        list:["Good working capital and cash flow ","Better inventory management. ","Good returns","Low cost","Digital, fast, and safe process","Up to 90% of invoices financed","No-collateral is required"]
      },
      {   id:7,
        Q:"Who all can avail Supply Chain Finance?",
        A:"Any private or public entity is eligible to avail supply chain finance. Sole proprietorship and partnership companies can also use this facility. "
      },
      {
        id:8,
        Q:"What is the repayment tenor of supply chain finance? ",
        A:"The repayment tenor of supply chain finance is 12 months. As per the business requirements, it can also be extended."
      },
      {
        id:9,
        Q:"What are the types of SME loans for supply chain finance? ",
        A:"The four common types of SME loans for supply chain finance are invoice financing, purchase order financing, supply chain financing, and inventory financing."
      },
      {
        id:10,
        Q:"How is the interest rate calculated and finalized by the company providing supply chain finance?",
        A:"The supply chain finance company calculates the interest rate based on how much of the credit limit the client has used up. "
      },
      {
        id:11,
        Q:"How many limits can a business avail from supply chain finance? ",
        A:"A business can receive up to 80% to 85% of the total value of the invoice. It also depends on the specific requirements and eligibility criteria set by the supply chain finance company. "
      }
],
},

    
}